export default __webpack_public_path__ + "static/media/btn-active-bg.196fe7a5.png";